import {useEffect} from "react";


const useSyncChildEnrolments = (enrolment) => {
    /*
                                    $set: {
                                        common: data.common,
                                        subscriber: data.subscriber,
                                        jointSubscriber: data.jointSubscriber,
                                        knowYourClient: data.knowYourClient,
                                        dependant: data.dependant,
                                        dependant2: data.dependant2,
                                        dependant3: data.dependant3,
                                        dependant4: data.dependant4,
                                        dependant5: data.dependant5,
                                    }

     */

    //When we have a Family Enrolment and we are changing some key values on the parent, we want to update the children as well.
    //This happens in the backend automatically, but we do it here to be in relative sync with the backend
    useEffect(() => {

        if (!enrolment.application.childApplications) {
            return;
        }

        if (enrolment.application.childApplications.length === 0) {
            return;
        }

        let newChildApplications = [];
        for (let child of enrolment.application.childApplications) {
            newChildApplications.push({
                ...child,
                common: enrolment.common,
                subscriber: enrolment.subscriber,
                jointSubscriber: enrolment.jointSubscriber,
                knowYourClient: enrolment.knowYourClient,
                dependant: enrolment.dependant,
                dependant2: enrolment.dependant2,
                dependant3: enrolment.dependant3,
                dependant4: enrolment.dependant4,
                dependant5: enrolment.dependant5,
            });
        }
        enrolment.setApplication({
            ...enrolment.application,
            childApplications: newChildApplications
        });

    }, [enrolment.common,
            enrolment.subscriber,
            enrolment.jointSubscriber,
            enrolment.knowYourClient,
            enrolment.dependant,
            enrolment.dependant2,
            enrolment.dependant3,
            enrolment.dependant4,
            enrolment.dependant5
    ]);
}

export default useSyncChildEnrolments;